import { render, staticRenderFns } from "./electronicSaw.vue?vue&type=template&id=2b8ae6e4&scoped=true&"
import script from "./electronicSaw.vue?vue&type=script&lang=js&"
export * from "./electronicSaw.vue?vue&type=script&lang=js&"
import style0 from "./electronicSaw.vue?vue&type=style&index=0&id=2b8ae6e4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8ae6e4",
  null
  
)

export default component.exports